import React, { useState } from "react";
import {Box, Table, Tabs} from "react-bulma-components";
import { Form } from "react-bulma-components";
import { Button } from "react-bulma-components";
import { Pagination } from "react-bulma-components";
import { Columns } from "react-bulma-components";
import {getDataFresh, getDepartmentsData, getQuotesData} from "../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import Spinner from "react-spinner-material";
import { useQuotesData } from "../../hooks/useQuotesData";
import useSelect from "../../hooks/useSelect";
import {formatDate, readableDate} from "../../utils";
import {useDepartmentsData} from "../../hooks/useDepartmentsData";
import DepartmentPicker from "../Job/DepartmentPicker";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import FilterHeading from "../Invoicing/FilterHeading";
import SearchBar from "../Utils/SearchBar";
import axios from "axios";
import {createSetDataFreshAction, createSetQuotesDataAction} from "../../actions/dataActions";
import {NotificationManager} from "react-notifications";
import InfoModal from "./InfoModal";

function Quote(props) {
  const [page, setPage] = useState(1);
  const [searchText, setSearchText] = useState();
  const [currentSearch, setCurrentSearch] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [searchFresh, setSearchFresh] = useState(1);
  const [view, setView] = useState("started");
  const [infoOpen, setInfoOpen] = useState(false);
  let dataFresh = useSelector(getDataFresh);
  const dispatch = useDispatch();
  const options = [
      { name: "Quotes", value: "quotes" },
      { name: "Started", value: "started"},
      { name: "No Active Jobs", value: "no_active_jobs"},
      { name: "Awaiting Approval", value: "all_jobs_completed"},
      { name: "Approved", value: "approved" },
      { name: "All", value: "all"}
  ];

  const [priced, pricedInput] = useSelect({
    label: "Priced",
    options: [
      { name: "All", value: "all"},
      { name: "Priced", value: "true"},
      { name: "Not Priced", value: "false"}
    ],
    initialValue: "all",
    callback: () => {
      setPage(1);
    }
  })

  // const [view, viewInput] = useSelect({
  //   label: "View",
  //   options: [
  //     { name: "Quotes", value: "quotes" },
  //     { name: "Started", value: "started"},
  //     { name: "No Active Job", value: "no_active_job"},
  //     { name: "Awaiting Approval", value: "all_jobs_completed"},
  //     { name: "Approved", value: "approved" },
  //     { name: "All", value: "all"}
  //   ],
  //   initialValue: "quotes",
  //   testId: "part-view",
  //   callback: () => {
  //     setPage(1);
  //   }
  // });

  const departmentsLoaded = useDepartmentsData({}, dataFresh);
  const departments = useSelector(getDepartmentsData);
  let params = { page };
  const [filters, setFilters] = useState({});
  const headings = [
    {
        label: "Quote no.",
    },
    {
        label: "Registration",
        field: "vehicle",
        labelField: "vehicle__registration"
    },
    {
        label: "Description"
    },
    {
      label: "Priced Status"
    },
    {
      label: "Earliest Workshop Date",
    },
    {
      label: "Provisional Start Date",
      field: "provisional_start_date",
      labelField: "provisional_start_date",
      date: true,
      noBlank: true
    },
    {
      label: "Items Not Started"
    },
    {
      label: "Quote Type",
      field: "quote_type",
      labelField: "quote_type"
    },
    {
        label: "Comments"
    },
    {
        label: "Customer",
        field: "customer",
        labelField: "customer__display_name"
    },
    {
        label: "Customer2",
        field: "customer2",
        labelField: "customer2__display_name"
    },
    {
      label: "Customer Invoice Number",
      field: "customer_invoice_number",
      labelField: "customer_invoice_number",
      blank: true
    },
    {
      label: "Customer2 Invoice Number",
      field: "customer2_invoice_number",
      labelField: "customer2_invoice_number",
      blank: true
    },
    {
        label: "Make"
    },
    {
        label: "Model"
    },
    {
      label: ""
    }
  ];

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  if(selectedDepartment){
    params.department = selectedDepartment;
  }

  if (currentSearch) {
    params.search = currentSearch;
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  if (view) {
    params.view = view;
  }
  if(priced){
    params.priced = priced
  }

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const complete = useQuotesData(params, dataFresh);
  const data = useSelector(getQuotesData);

  const onDepartmentChange = (e) => {
    setSelectedDepartment(e.target.value);
  }


  const onPriced = (e, index) => {
    let quoteToPrice = data.results[index];
    const conf = {
      url: props.endpoint+"quotes/priced",
      method: "put",
      data: quoteToPrice
    }
    axios(conf).then(res => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
    }).catch(err => {
      NotificationManager.error("There was an error setting that quote as priced")
    })
  }

  if (!complete || !departmentsLoaded) {
    return (
      <Box>
        <Spinner
          className="spinner-centre"
          size={120}
          spinnerColor={"#3273dc"}
          spinnerWidth={2}
        />
      </Box>
    );
  }

  document.title = "Quotes";

  return (
    <div>
      <Box>
        <Columns>
          <Columns.Column>
            <Button
              color={"info"}
              onClick={() => setInfoOpen(true)}
            >
              Info
            </Button>
          </Columns.Column>
          {pricedInput}
          <Columns.Column>
            <DepartmentPicker
              onDepartmentChange={onDepartmentChange}
              selectedDepartment={selectedDepartment}
              departments={departments}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Label>Search for a Quote</Form.Label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              clear={clear}
            />
          </Columns.Column>
          <Columns.Column>
            <Form.Field>
              <Form.Control>
                <Button
                  onClick={() => props.history.push("/editquote")}
                  color="success"
                  className="is-pulled-right"
                >
                  New Quote+
                </Button>
              </Form.Control>
            </Form.Field>
          </Columns.Column>
        </Columns>
      </Box>
      <Box>
        <Columns>
          <Columns.Column>
            <h1 className="title">Quotes</h1>
          </Columns.Column>
        </Columns>
        <Tabs type="toggle" align="centered">
          {options.map(option => (
            <Tabs.Tab active={view === option.value} onClick={() => setView(option.value)}>
              {option.name}
            </Tabs.Tab>
          ))}
        </Tabs>
        <Columns>
          <Columns.Column>
            <Table size={"fullwidth"} className="table is-hoverable is-fullwidth is-striped">
              <thead>
                <tr className="small-row-black">
                  {headings.map(heading => {
                    if (!heading.field) {
                      return <th key={heading.label}>{heading.label}</th>;
                    }
                    if (heading.blank) {
                      return (
                        <FilterBlankHeading
                          key={heading.label}
                          heading={heading}
                          setFilters={f => {
                            setPage(1);
                            setFilters(f);
                          }}
                          filters={filters}
                        />
                      );
                    }
                    return (
                      <FilterHeading
                        key={heading.label}
                        heading={heading}
                        setFilters={f => {
                          setPage(1);
                          setFilters(f);
                        }}
                        filters={filters}
                        options={data.filter_list[heading.field]}
                      />
                    );
                  })}
                  {view === 'approved' &&
                    <th>Approver</th>
                  }
                </tr>
              </thead>
              <tbody>
                {data.results.map((value, index) => {
                  let highlightClass = "";
                  if (value.has_jobs) {
                    if (value.ready_for_approval) {
                      highlightClass = "table-highlight-green";
                    } else if(value.has_finished_and_not_started_jobs && !value.has_started_job){
                      highlightClass = "table-highlight-red";
                    } else {
                      highlightClass = "table-highlight-orange";
                    }
                  }
                  return (
                    <tr
                      className={`clickable small-row-black ${highlightClass}`}
                      onClick={() =>
                        window.open(`/editquote/${value.id}`, "_self")
                      }
                      key={value.id}
                    >
                      <td>{value.id}</td>
                      <td>{value.vehicle.registration}</td>
                      <td>{value.description}</td>
                      <td>{value.priced ? "Priced" : "Not Priced"}</td>
                      <td>{readableDate(value.earliest_workshop_date)}</td>
                      <td>{readableDate(value.provisional_start_date)}</td>
                      <td>{value.not_started_work_items}</td>
                      <td>{value.quote_type}</td>
                      <Form.Field className="has-addons">
                        <Form.Control>
                          <Form.Textarea
                            rows={2}
                            className="small-row-black min-column-width"
                            type="text"
                            value={value.comments_list.length > 0 ? readableDate(formatDate(new Date(value.comments_list[value.comments_list.length -1].created))) +"\n"+ value.comments_list[value.comments_list.length -1].text : ""}
                            disabled
                            readOnly
                          />
                        </Form.Control>
                      </Form.Field>
                      <td>{value.customer}</td>
                      <td>{value.customer2}</td>
                      <td>{value.customer_invoice_number}</td>
                      <td>{value.customer2_invoice_number}</td>
                      <td>{value.vehicle.make ? value.vehicle.make.name : ""}</td>
                      <td>{value.vehicle.model ? value.vehicle.model.name : ""}</td>
                      {view === 'approved' &&
                      <td>{value.approving_user ? `${value.approving_user.first_name} ${value.approving_user.last_name}` : ""}</td>
                      }
                      {!value.priced ?
                        <td onClick={e => e.stopPropagation()}>
                          <Button
                            color={"success"}
                            onClick={(e) => onPriced(e, index)}
                          >
                            Priced
                          </Button>
                        </td> : <td></td>
                      }
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </Columns.Column>
        </Columns>
        <Pagination
            showFirstLast={true}
            onChange={setPage}
            current={page}
            total={Math.ceil(data.count / 25)}
          ></Pagination>
        <InfoModal show={infoOpen} setShow={setInfoOpen}/>
      </Box>
    </div>
  );
}

export default Quote;
